import { Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import RequireAuth from "./RequireAuth";

/* ================= PUBLIC ================= */
import Home from "./pages/Home";
import Videos from "./pages/Videos";
import Shorts from "./pages/Shorts";
import VideoDetails from "./pages/VideoDetails";
import Post from "./pages/Post";
import ReferralRedirect from "./pages/ReferralRedirect";
import Songs from "./pages/Songs";
import SongDetails from "./pages/SongDetails";


/* ================= AUTH ================= */
import Login from "./pages/Login";
import Register from "./pages/Register";
import FillProfile from "./pages/FillProfile";

/* ================= USER PANEL ================= */
import UserPanelLayout from "./panel/UserPanelLayout";
import Dashboard from "./panel/Dashboard";
import ContentManager from "./panel/ContentManager";
import Settings from "./panel/Settings";
import Subscriptions from "./panel/Subscriptions";
import Analytics from "./panel/Analytics";
import Monetization from "./panel/Monetization";
import Withdraw from "./panel/Withdraw";
import HomeFeed from "./pages/HomeFeed";

/* ? ONLY ONE PROFILE IMPORT */
import Profile from "./pages/Profile";

/* ======== EDIT ROUTES ======== */
import EditVideo from "./panel/EditVideo";
import EditPost from "./panel/EditPost";
import EditSong from "./panel/EditSong";

/* ================= CREATOR PAGES ================= */
import UploadVideo from "./pages/UploadVideo";
import UploadShort from "./pages/UploadShort";
import UploadSong from "./panel/UploadSong";
import Channel from "./pages/Channel";

export default function UserRouter() {
  return (
    <Routes>

      {/* ================= PUBLIC SITE ================= */}
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="videos" element={<Videos />} />
        <Route path="shorts" element={<Shorts />} />
        <Route path="shorts/:id" element={<Shorts />} />
        <Route path="video/:id" element={<VideoDetails />} />
        <Route path="post" element={<Post />} />
        <Route path="post/:id" element={<Post />} />
        <Route path="channel/:channelId" element={<Channel />} />
        <Route path="songs" element={<Songs />} />
        <Route path="song/:id" element={<SongDetails />} />
        <Route path="ref/:code" element={<ReferralRedirect />} />
      </Route>

      {/* ================= AUTH ================= */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/fill-profile" element={<FillProfile />} />

      {/* ================= USER PANEL ================= */}
      <Route
        path="/user"
        element={
          <RequireAuth>
            <UserPanelLayout />
          </RequireAuth>
        }
      >
        {/* Dashboard */}
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />

        {/* Creator Studio */}
        <Route path="content" element={<ContentManager />} />
        
        <Route path="songs" element={<Songs />} />
        <Route path="song/:id" element={<SongDetails />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="settings" element={<Settings />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="monetization" element={<Monetization />} />
        <Route path="withdraw" element={<Withdraw />} />

        {/* ? Correct Profile Route */}
        <Route path="profile" element={<Profile />} />
        <Route path="profile/:username" element={<Profile />} />

        {/* Upload */}
        <Route path="upload-video" element={<UploadVideo />} />
        <Route path="upload-short" element={<UploadShort />} />
        <Route path="upload-song" element={<UploadSong />} />

        {/* User Feed */}
        <Route path="home" element={<HomeFeed />} />
        <Route path="videos-feed" element={<Videos />} />
        <Route path="shorts-feed" element={<Shorts />} />
        <Route path="posts-feed" element={<Post />} />

        {/* Internal Play Routes */}
        <Route path="video/:id" element={<VideoDetails />} />
        <Route path="shorts/:id" element={<Shorts />} />
        <Route path="post/:id" element={<Post />} />

        {/* Edit */}
        <Route path="edit-video/:id" element={<EditVideo />} />
        <Route path="edit-post/:id" element={<EditPost />} />
        <Route path="edit-song/:id" element={<EditSong />} />

        {/* Channel inside panel */}
        <Route path="channel/:channelId" element={<Channel />} />

      </Route>

    </Routes>
  );
}
